import { InputBase, styled } from '@mui/material'
import { forwardRef, useCallback } from 'react'
import { colorPalette } from '../../style/colorPalette'

export interface ProjectMemberInputProps {
  value: string
  onChange: (value: string) => void
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void
  onFocus?: () => void
  inputRef?: React.RefObject<HTMLInputElement>
  autoFocus?: boolean
  disabled?: boolean
  placeholder?: string
}

export const ProjectMemberInput = forwardRef<
  HTMLDivElement,
  ProjectMemberInputProps
>(
  (
    {
      value,
      onChange,
      onKeyDown,
      onFocus,
      inputRef,
      autoFocus = true,
      disabled = false,
      placeholder,
    },
    ref
  ) => {
    const handleChange = useCallback(
      (event: React.ChangeEvent<HTMLInputElement>) => {
        onChange(event.target.value)
      },
      [onChange]
    )

    return (
      <StyledInputBase
        ref={ref}
        inputRef={inputRef}
        value={value}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        onFocus={onFocus}
        autoFocus={autoFocus}
        disabled={disabled}
        placeholder={placeholder}
      />
    )
  }
)

const StyledInputBase = styled(InputBase)({
  flex: 1,
  fontFamily: 'Noto Sans JP',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: 1,
  color: colorPalette.monotone[10],
  '& input': {
    padding: 0,
  },
})
